import CardPlacingOrder from '@/entities/cart-page/CardPlacingOrder'
import { email_pattern } from '@/shared/constants/common'
import { useGetIsAuthUser } from '@/shared/hooks/useGetIsAuthUser'
import {
    changeCurrentStep,
    updateShippingAddress,
} from '@/shared/store/slice/cartSlice'
import { useEffect, useState } from 'react'
import { Form, InputGroup } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'

export const ShippingAddress = ({userInfo}) => {
    const {
        customer,
        currentStep: step,
        shippingMethodValue,
        areaZoneId,
    } = useSelector((state) => state.cartActions)

    const [name, setName] = useState(customer ? customer.firstname : '')
    const [lastName, setLastName] = useState(customer ? customer.lastname : '')
    const [email, setEmail] = useState(customer ? customer.email : '')
    const [emailIsValid, setEmailIsValid] = useState(false)
    const [phone, setPhone] = useState(customer ? customer.telephone : '')
    const [address, setAddress] = useState('')

    useEffect(
        function () {
            if (!customer) {
                return
            }
            setName(customer.firstname)
            setLastName(customer.lastname)
            setEmail(customer.email)
            setPhone(customer.telephone)
            if (shippingMethodValue === 'flat.flat') {
                setAddress(customer.address)
            }
        },
        [customer]
    )

    const dispatch = useDispatch()

    const handleChangeStep = () => {
        if (email_pattern.test(email)) {
            dispatch(
                updateShippingAddress({
                    shipping_address: {
                        firstname: name,
                        lastname: lastName,
                        email: email,
                        telephone: phone,
                        address_1: address ? address : '',
                        country_id: 176,
                        zone_id: areaZoneId
                    },
                    userInfo
                })
            )
        } else {
            alert('Некорректно введен E-mail!')
        }
    }

    const handleChange = (e) => {
        dispatch(changeCurrentStep(4))
    }

    return (
        <CardPlacingOrder
            stepTitle={'Шаг 4: Адрес доставки'}
            changeStep={handleChangeStep}
            className={step < 4 ? 'disabled-step' : ''}
            currentStep={step === 4}
            textButton={'Следующий шаг'}
            isValid={
                name &&
                lastName &&
                email &&
                phone &&
                (address || shippingMethodValue !== 'flat.flat')
            }
        >
            <InputGroup className={'flex-column align-items-start gap-1 w-100'}>
                <label>Имя</label>
                <Form.Control
                    id="cart-customer-name"
                    value={name}
                    onChange={(e) => handleChange(setName(e.target.value))}
                    className={'p-3 w-100'}
                    placeholder={'Введите имя'}
                />
            </InputGroup>
            <InputGroup className={'flex-column align-items-start gap-1 w-100'}>
                <label>Фамилия</label>
                <Form.Control
                    id="cart-customer-lastName"
                    value={lastName}
                    onChange={(e) => handleChange(setLastName(e.target.value))}
                    className={'p-3 w-100'}
                    placeholder={'Введите фамилию'}
                />
            </InputGroup>
            <InputGroup className={'flex-column align-items-start gap-1 w-100'}>
                <label>E-Mail</label>
                <Form.Control
                    id="cart-customer-email"
                    isInvalid={emailIsValid && email}
                    value={email}
                    onChange={(e) => handleChange(setEmail(e.target.value))}
                    onBlur={(e) =>
                        setEmailIsValid(!email_pattern.test(e.target.value))
                    }
                    className={'p-3 w-100'}
                    placeholder={'Введите E-Mail'}
                />
                <Form.Control.Feedback type="invalid">
                    Некорректный эмайл адрес
                </Form.Control.Feedback>
            </InputGroup>
            <InputGroup className={'flex-column align-items-start gap-1 w-100'}>
                <label>Телефон</label>
                <Form.Control
                    id="cart-customer-phone"
                    value={phone}
                    onChange={(e) => handleChange(setPhone(e.target.value))}
                    className={'p-3 w-100'}
                    placeholder={'Введите телефон'}
                />
            </InputGroup>
            {shippingMethodValue === 'flat.flat' && (
                <InputGroup
                    className={'flex-column align-items-start gap-1 w-100'}
                >
                    <label>Адрес (город, улица, дом, домофон)</label>
                    <Form.Control
                        id="cart-customer-address"
                        value={address}
                        onChange={(e) =>
                            handleChange(setAddress(e.target.value))
                        }
                        className={'p-3 w-100'}
                        placeholder={'Введите адрес'}
                    />
                </InputGroup>
            )}
        </CardPlacingOrder>
    )
}
